<template>
    <b-container>
      <b-row>
        <b-col md="5">
          <div class="mt-3">
            <div class="image-icons">
              <div>
                <b-icon icon="heart" class="action-icon"></b-icon>
              </div>
              <div>
                <b-icon icon="share" class="action-icon"></b-icon>
              </div>
            </div>
            <b-carousel
              id="carousel-fade"
              style="text-shadow: 0px 0px 2px #000"
              fade
              indicators
              img-width="1024"
              img-height="480"
            >
              <b-carousel-slide
                caption=""
                img-src="https://picsum.photos/1024/480/?image=10"
              ></b-carousel-slide>
              <b-carousel-slide
                caption=""
                img-src="https://picsum.photos/1024/480/?image=12"
              ></b-carousel-slide>
              <b-carousel-slide
                caption=""
                img-src="https://picsum.photos/1024/480/?image=22"
              ></b-carousel-slide>
            </b-carousel>
          </div>
          <div>
            <h3 class="mt-3 heading">Rate & Reviews</h3>
            <div>
              <template>
                <div>
                  <b-form-rating
                    class="review-star"
                    v-model="starValue"
                    readonly
                    variant="warning"
                    inline
                    no-border
                  ></b-form-rating>
                </div>
              </template>
              <div>
                <p class="review-title">Good Service</p>
                <p>
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Deleniti, asperiores.
                </p>
                <p class="reviewer">John George</p>
              </div>
              <hr />
            </div>
          </div>
        </b-col>
        <b-col offset="2" md="5">
            <div>
              <h3 class="mt-2 heading">Hospital Name</h3>
              <b-row>
                <b-col>
                  <p class="hospital-text reviewer mb-0"
                    >St. Michael Church Road, Mumbai
                    , Maharashtra</p
                  >
                </b-col>
              </b-row>
            </div>
            <div class="hospital-text mt-2 mb-3">
                <b>Contact:</b>
                <span>+91 987654321</span>
            </div>
            <div class="hospital-text mt-0">
              <b-row>
                <b-col>
                 <b class="mb-0 hospital-text">Open Time: 7:00 AM - Close Time: 10:00 PM</b>
                </b-col>
              </b-row>
            </div>
            <div class="mt-3">
              <b class="hospital-text">About Hospital</b>
              <p>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iste
                reiciendis quasi minima, et dolorum nostrum explicabo nam
                perferendis voluptates labore aliquam accusantium pariatur sit
                incidunt quas sequi est nihil doloremque!
              </p>
            </div>
    
            <div class="mt-3" style="font-size:15px">
              <b >Major Specialities</b>
              <ul class="mt-2">
                <li> Cardiac Surgery - Adult. ...</li>
                <li> Cardiology - Adult. ...</li>
                <li> Microbiology. ...</li>
                <li> Radiology. ...</li>
                <li> General Surgery. ...</li>
                <li> Gastroenterology - Medical. ...</li>
                <li> Electrophysiology. ...</li>
                <li> Gastroenterology - Surgical</li>
              </ul>
            </div>
            <div class="text-center mt-5">
              <b-button block variant="custom" class="custom-button">Proceed</b-button>
          </div>
          </b-col>
      </b-row>
      <b-row>
        <b-col>
            <b-container>
                <template v-if="$options.components['advertisement-bottom-banner']">
                  <advertisement-bottom-banner />
                </template>
              </b-container>
        </b-col>
      </b-row>
    </b-container>
  </template>
  
  <script>
  import { mapState } from "vuex";
  
  export default {
    data() {
      return { starValue: 4.5 };
    },
    computed: {
      ...mapState({
        diagnosticBanner: (state) => state.healthCare.marketBanner,
      }),
    },
    async mounted() {
      this.isLoading = true;
      let payload = {
        city: "GHATAL",
        placement: "SHOP_TOP",
        provider: "62288a7d9e0dd452af89f0d1",
      };
      await this.$store.dispatch("healthCare/fetchMarketBanner", payload);
  
      this.isLoading = false;
    },
  };
  </script>
  
  <style scoped>
  .heading {
    font-weight: 600;
    font-size: 26px;
  }
  .image-icons {
      display: flex;
      flex-direction: column;
      position: absolute;
      z-index: 10;
      top: 40px;
      right: 24px;
  }
  .action-icon{
      height: 30px;
      width: 30px;
      padding: 5px;
      cursor: pointer;
      border-radius: 6px;
      background-color: #ffffff;
  }
  .review-title {
    font-weight: 500;
  }
  .reviewer {
    color: #9e9e9e;
  }
  .review-star {
    padding: 0px;
  }
  .hospital-text{
    font-size: 15px;
    line-height: 15px
  }
  .custom-button {
    background-color: #FE7B08 !important;
    color: white !important;
}
  </style>
  